export default "__VITE_ASSET__vgYqcMVq__"